import type { AxiosInstance } from 'axios'

import type { UserPermissions } from '../../types/user-permissions.types'

export interface PermissionsService {
  getPermissions: () => Promise<UserPermissions>
}

export const createPermissionsService = (
  httpClient: AxiosInstance
): PermissionsService => ({
  getPermissions: async () => {
    const { data } = await httpClient.get<UserPermissions>('permissions')

    return data
  }
})
